export const DEFAULT_LDAP_USER_SEARCH_FILTER = "(&(!(objectClass=computer))(!(userAccountControl:1.2.840.113556.1.4.803:=2)))";
